import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
export const Controls = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1innx240"
} : {
  target: "e1innx240",
  label: "Controls"
})(process.env.NODE_ENV === "production" ? {
  name: "1eoy87d",
  styles: "display:flex;justify-content:space-between"
} : {
  name: "1eoy87d",
  styles: "display:flex;justify-content:space-between/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbnRyb2xzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUNtQyIsImZpbGUiOiJDb250cm9scy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmV4cG9ydCBjb25zdCBDb250cm9scyA9IHN0eWxlZC5kaXYgYFxuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG5gO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9Q29udHJvbHMuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});